import React from "react";
import ReactDOM from "react-dom";
import "./styles/tailwind.css";
import App from "./routes/App";
import reportWebVitals from "./reportWebVitals";
import { ModalContextProvider } from "./context/ModalContext";

ReactDOM.render(
  <React.StrictMode>
    <ModalContextProvider>
      <App />
    </ModalContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
